import type { FC } from "react";

import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Typography } from "~/shared/ui-kit/typography/Typography";

type Props = { index: number };
export const NumberInCircle: FC<Props> = ({ index }) => {
  return (
    <Flex
      align="center"
      justify="center"
      className="min-w-10 min-h-10 lg:max-w-11 lg:max-h-11 rounded-full border-2 border-white text-center "
    >
      <Typography size="large">{index}</Typography>
    </Flex>
  );
};
